var map = {
	"./3-2template.jpg": "b2c0",
	"./FSD/features/customizable.jpg": "c6f4",
	"./FSD/features/early-detection.jpg": "4eeb",
	"./FSD/features/embedded-board.jpg": "0037",
	"./FSD/features/heop.jpg": "e8ab",
	"./FSD/features/logos.jpg": "0de8",
	"./FSD/features/privacy.jpg": "76e8",
	"./FSD/views/fabric-factory-view.jpg": "8635",
	"./FSD/views/factory-premises-view.jpg": "4931",
	"./FSD/views/first-view.jpg": "f2fa",
	"./FSD/views/sample1-view.jpg": "21d5",
	"./FSD/views/valve-factory-view.jpg": "df2b",
	"./News/exhibition.jpg": "0a0b",
	"./Tech/cross-sector-col.jpg": "a1ec",
	"./Tech/cross-sector-row.jpg": "011b",
	"./Tech/digital-twin-col.jpg": "6046",
	"./Tech/digital-twin-row.jpg": "b134",
	"./Tech/edge-5g-col.jpg": "982a",
	"./Tech/edge-5g-row.jpg": "cec6",
	"./Tech/green-circular-col.jpg": "7f5a",
	"./Tech/green-circular-row.jpg": "85bd",
	"./Tech/nlp-5g-col.jpg": "be5f",
	"./Tech/nlp-5g-row.jpg": "6689",
	"./Tech/qc-col.jpg": "19cd",
	"./Tech/qc-row.jpg": "ec33",
	"./Tech/robotics-col.jpg": "4652",
	"./Tech/robotics-row.jpg": "c261",
	"./Tech/tech-back1.jpg": "4572",
	"./Tech/tech-back2.jpg": "bfc8",
	"./background-smoke.jpg": "01c1",
	"./second-view.jpg": "07e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";